$(() => {
    // Verifica hash ao iniciar
    URI.init();

    //PopUP's
    if ($('#popupModal').length === 1) {
        if (!$.cookie('popup_shown')) {
            (<any>$('#popupModal')).modal('show');
            // $.cookie('popup_shown', 'true', { expires: 1 })
        }
    }

    // // Menu
    // $(".m-m-submenu a").click(function() {
    //     $(this).parent('.m-m-submenu').hide();
    // });

    // $(".m-menu").hover(function(){
    //     $(this).find('.m-m-submenu').slideDown();
    // }, function() {
    //     $(this).find('.m-m-submenu').hide();
    // });

    //Acessibilidade
    $('#font-plus-button').click(function () {
        let tamanhoFonte = $('#content').css('font-size');
        let tf = parseFloat(tamanhoFonte);
        if (tf < 29) {
            $('#content').css({ 'font-size': tf + 5 });
        }
    });
    $('#font-less-button').click(function () {
        let tamanhoFonte = $('#content').css('font-size');
        let tf = parseFloat(tamanhoFonte);
        if (tf > 14) {
            $('#content').css({ 'font-size': tf - 5 });
        }
    });

    $('#background-contrast-button').click(() => {
        if ($(document).find('.p5-bgcolor-white').length) {
            $('.p5-accessibility-body').removeClass('p5-bgcolor-white').addClass('p5-bgcolor-black');
            $('.p5-accessibility-content').removeClass('p5-bgcolor-white').addClass('p5-bgcolor-black');
        } else if ($(document).find('.p5-bgcolor-black').length) {
            $('.p5-accessibility-body').removeClass('p5-bgcolor-black').addClass('p5-bgcolor-white');
            $('.p5-accessibility-content').removeClass('p5-bgcolor-black').addClass('p5-bgcolor-white');
        }
    });

    // Menu fixed scroll
    var windowWidth = $(window).width();

    if (windowWidth > 767) {
        $(window).scroll(() => {
            let menuTop = $('.header').outerHeight();
            let menuHeight = $('#menu-desktop').outerHeight();
            let scrollTop = $(window).scrollTop();
            if (scrollTop > menuTop) {
                $('#menu-desktop').addClass('fixed-top navbar-scrolled');
                $('body').css('margin-top', menuHeight);
                $('#footer-btn-back-top').fadeIn('slow');
            } else {
                $('#menu-desktop').removeClass('fixed-top navbar-scrolled');
                $('body').css('margin-top', 0);
                $('#footer-btn-back-top').fadeOut('slow');
            }
        });
    }

    $(document).off('click', '.menu-mobile');
    $(document).on('click', '.menu-mobile', function (e) {
        e.stopPropagation();
        $('.menu-mobile-container').addClass('open');
    });

    $(document).off('click', '.menu-mobile-container-click');
    $(document).on('click', '.menu-mobile-container-click', function (e) {
        e.stopPropagation();
        $('.menu-mobile-container').removeClass('open');
        (<any>$('.collapse')).collapse('hide');
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.menu-mobile-container').length === 0) {
            $('.menu-mobile-container').removeClass('open');
            (<any>$('.collapse')).collapse('hide');
        }
    });

    /*Search*/
    $('#search-btn').click(function () {
        let search: any = $('#search').val();
        if (search.length > 2) {
            window.location.href = '/#/search/' + encodeURIComponent(search);
        }
    });

    $('#search').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('#search-btn').click();
        }
    });

    // $("#search-btn-m").click(function(){
    //     let search: any = $("#search-m").val();
    //     if (search.length > 2) {
    //         window.location.href = '/#/search/'+encodeURIComponent(search);
    //     }
    // });

    // $("#search-m").keyup(function (event: any) {
    //     if(event.keyCode == 13){
    //         $("#search-btn-m").click();
    //     }
    // });

    // $("#search-m").click(function (event: any) {
    //     event.stopPropagation();
    // });

    $('#footer-btn-back-top').click(function () {
        $('body, html').animate({ scrollTop: 0 }, 900);
    });
});
